import { BalanceTile } from './BalanceTile';
import { TimeOffIconSvg } from './TimeOffIconSvg';
import type { BalanceTileData } from '../lib/balanceTiles';

// Renders a responsive grid of colored balance tiles. `className` controls the
// grid columns so callers keep their layout (e.g. 'grid-cols-2' vs the default).
// Build the tiles with `balanceToTile` from lib/balanceTiles, or pass them directly.
export function BalanceTileGrid({
  tiles,
  className = 'grid-cols-1 sm:grid-cols-2',
}: {
  tiles: BalanceTileData[];
  className?: string;
}) {
  return (
    <div className={`grid gap-x-3 gap-y-4 ${className}`}>
      {tiles.map((t) => (
        <BalanceTile
          key={t.key}
          label={t.label}
          color={t.color}
          icon={<TimeOffIconSvg icon={t.icon} className="h-4 w-4" />}
          value={t.value}
          unit={t.unit}
          subtitle={t.subtitle}
        />
      ))}
    </div>
  );
}
